/**
 * Discount status enum for the admin portal
 */
var DiscountStatus;
(function (DiscountStatus) {
    DiscountStatus["ACTIVE"] = "Active";
    DiscountStatus["SCHEDULED"] = "Scheduled";
    DiscountStatus["EXPIRED"] = "Expired";
})(DiscountStatus || (DiscountStatus = {}));

export { DiscountStatus };
//# sourceMappingURL=DiscountStatus.js.map
